import './instrument.js'; // Sentry must be first
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import "./index.css";
import App from "./App.jsx";
import { WalletProvider } from "./context/WalletContex.jsx";

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh', gap: 16, padding: 24, textAlign: 'center', background: '#090817', color: '#fff' }}>
        <div style={{ fontSize: 40 }}>⚠️</div>
        <h2 style={{ margin: 0, fontSize: 20, fontWeight: 800 }}>Something went wrong</h2>
        <p style={{ margin: 0, color: '#8B8FA8', fontSize: 14 }}>The error has been reported. Please refresh to continue.</p>
        <button onClick={() => window.location.reload()} style={{ padding: '12px 28px', borderRadius: 14, border: 'none', background: '#7C5CF6', color: '#fff', fontSize: 15, fontWeight: 700, cursor: 'pointer' }}>
          Refresh
        </button>
      </div>
    }>
      <WalletProvider>
        <App />
      </WalletProvider>
    </Sentry.ErrorBoundary>
  </StrictMode>
);
